import { ApiService } from './ApiService';
import { KdsApiService } from './KdsApiService';

const kdsApi = new KdsApiService();
const webApi = new ApiService();
export { webApi, kdsApi };
